module.exports = "@charset \"UTF-8\";\n:host .content  > div span {\n  text-transform: capitalize; }\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/real-time/real-time/real-time-service-levels-popup/real-time-service-levels-popup.component.scss
// module id = ./src/app/real-time/real-time/real-time-service-levels-popup/real-time-service-levels-popup.component.scss
// module chunks = main